import { render, staticRenderFns } from "./SuggestionContent.vue?vue&type=template&id=1bd3aa90"
import script from "./SuggestionContent.vue?vue&type=script&lang=js"
export * from "./SuggestionContent.vue?vue&type=script&lang=js"
import style0 from "./SuggestionContent.vue?vue&type=style&index=0&id=1bd3aa90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports